<template>
  <div class="menu">
    <div class="title">
      <img class="t_ai" src="./imgs/composition.png" alt="">
      <img class="t_img" src="./imgs/title-com.png" alt="">
    </div>
    <div class="box">
      <div
        :class="['row', indexId == item.id ? 'select' : '']"
        v-for="item in dataList"
        :key="item.chatType"
        @click="chatTypeHandle(item)"
      >
        <img :src='indexId == item.id ? item.imgChecked : item.img' alt="">
        <span>{{ item.name }}</span>
      </div>
    </div>
    <template v-if="!memberCategoryId">
      <div class="member" v-if="pointLeft">
        <div class="member-left">
          <div>升级会员享更多权益</div>
          <div class="member-left-small">剩余 <span>{{ pointLeft }}</span> AI豆</div>
        </div>
        <div class="member-btn" @click="clickShowMember">去升级</div>
      </div>
      <img v-else class="free-noleft" src="@/assets/imgs/free-noleft.png" alt="" @click="clickShowMember">
    </template>
    <template v-else>
      <div class="pi">
        <div class="pi-left">
          <div v-if="memberCategoryId == 2902 || memberCategoryId == 3074">升级PRO高级会员</div>
          <div v-else>当前PRO高级会员</div>
          <div class="pil-small" v-if="pointLeft">剩余 <span>{{ pointLeft }}</span> AI豆</div>
        </div>
        <div class="pi-btn" @click="clickShowMember">
          <span  v-if="memberCategoryId == 2902 || memberCategoryId == 3074">去升级</span>
          <span v-else>去续费</span>
        </div>
      </div>
    </template>
    <!-- <div class="bottom" @click="toRechargeHandle">
      <div class="bot_text">
        <p>AI豆购买&gt;</p>
        <p>购买畅快用</p>
      </div>
      <img src="@/assets/imgs/recharge.png" alt="">
    </div> -->
    <div class="dialog">
      <el-dialog
        v-model="dialogVisible"
        width="1000px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        center
      > 
        <template #title>
          <div class="switchTabs">
            <!-- <div :class="switchType==1?'ft600':''" style="margin-right:24px;cursor: pointer;" @click="switchTypeCall(1)">
              许愿功能
              <div v-if="switchType==1" class="line"></div>
              <div v-else class="whiteLine"></div>
            </div> -->
            <div :class="switchType==2?'ft600':''" style="margin-left: 24px;cursor: pointer;" @click="switchTypeCall(2)">
              意见反馈
              <div v-if="switchType==2" class="line"></div>
              <div v-else class="whiteLine"></div>
            </div>
          </div>
        </template>
        <div>
          <div class="dialog-title">
            <img src="../../assets/imgs/happy.png" />
            <div v-if="switchType==1">许愿你想要的功能，呼声高的功能将会优先开放</div>
            <div v-if="switchType==2">反馈内容（必填）</div>
          </div>
          <div v-if="switchType==1">
            <el-input
              v-model="wishContent"
              :rows="8"
              maxlength="1000"
              type="textarea"
              placeholder="许愿您想要的任何其他功能～"
              resize="none"
            />
            <div class="count">{{wishContent.length}}/1000</div>
          </div>
          <div v-if="switchType==2">
            <el-input
              v-model="ideaContent"
              :rows="8"
              maxlength="1000"
              type="textarea"
              placeholder="请输入您对我们的意见或建议，我们会尽快处理。"
              resize="none"
            />
            <div class="count">{{ideaContent.length}}/1000</div>
          </div>
        </div>
        <template #footer>
          <div class="dialog-footer">
            <div class="confirm" @click="confirm">提 交</div>
          </div>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
const router = useRouter();
const route = useRoute();
import { getMenu, getPointLeft } from '@/api/index';
import { ElMessage } from 'element-plus';
import { addFeedback1 } from '@/api/index';
import { mittBus } from "@/utils/bus";
const intelligenceInfo = JSON.parse(localStorage.getItem('intelligenceInfo')) ;
const memberCategoryId = intelligenceInfo.memberCategoryId // 用户会员类别Id 2902基础会员 2904高级会员

watch(route, (val) => {
  dataList.value.forEach(item => {
    if (item.name == val.meta.name) {
      indexId.value = item.id;
      sessionStorage.setItem('indexId', item.id);
    };
  });
},{deep: true});

const indexId = ref(sessionStorage.getItem('indexId') || 1);
const dataList = ref([]);

const getMenuM = () => {
  getMenu().then(res => {
    if (res.success) {
      dataList.value = res.data.map(item => {
        switch (item.name) {
          case '首页':
              item.img = require('@/assets/imgs/left-index.png')
              item.imgChecked = require('@/assets/imgs/left-index-checked.png')
            break;
          case '作业':
              item.img = require('@/assets/imgs/left-task.png')
              item.imgChecked = require('@/assets/imgs/left-task-checked.png')
            break;
          case '班级':
              item.img = require('@/assets/imgs/left-class.png')
              item.imgChecked = require('@/assets/imgs/left-class-checked.png')
            break;
          case '学情':
              item.img = require('@/assets/imgs/left-study.png')
              item.imgChecked = require('@/assets/imgs/left-study-checked.png')
            break;
          case '批阅记录':
              item.img = require('@/assets/imgs/left-record.png')
              item.imgChecked = require('@/assets/imgs/left-record-checked.png')
            break;
          case '意见反馈':
              item.img = require('@/assets/imgs/left-yijian.png')
              item.imgChecked = require('@/assets/imgs/left-yijian-checked.png')
            break;
          default:
            break;
        }
        return item
    
      })
    } else {
      ElMessage.error(res.msg);
    };
  });
};
getMenuM();

// 切换
const chatTypeHandle = (val) => {
  if (val.id == 6) return  wish();
  indexId.value = val.id;
  sessionStorage.setItem('indexId', val.id);
  if (val.id == 1) {
    router.push('/composition/index')
  }
  if (val.id == 2) {
    router.push('/composition/work')
  }
  if (val.id == 3) {
    router.push('/composition/class')
  }
  if (val.id == 4) {
    router.push('/composition/studyDetail')
  }
  if (val.id == 5) {
    router.push('/composition/reviewRecord')
  }
};
const toRechargeHandle = () => {
  router.push('/recharge1')
};


let wishContent = ref('')
let ideaContent = ref('')
let dialogVisible = ref(false)
let switchType = ref(2)
const wish = ()=>{
  wishContent.value = ''
  ideaContent.value = ''
  switchType.value = 2
  dialogVisible.value=true
}
const switchTypeCall = (type)=>{
  switchType.value=type
}

const confirm = ()=>{
  if(switchType.value==1&&!wishContent.value.trim()) return ElMessage.warning('请输入愿望')
  if(switchType.value==2&&!ideaContent.value.trim()) return ElMessage.warning('请输入建议')
  addFeedback1({
    msg: switchType.value==1?wishContent.value:ideaContent.value,
    // type: switchType.value==1? 1: 0
  }).then(res=>{
    if(res.code==200){
      ElMessage.success('提交成功')
      dialogVisible.value=false
    }else{
      ElMessage.error(res.message)
    }
  })
}


//获取余额
const pointLeft = ref()
const getPointLeftM = async () => {
  const res = await getPointLeft()
  if (res.code == 200) {
    pointLeft.value = res.data.pointLeft
  }
}
getPointLeftM()
// 显示会员
const clickShowMember = () => {
  console.log('clickShowMember', intelligenceInfo)
  if(!intelligenceInfo.memberCategoryId ) {
    //去开通
    mittBus.emit('showMember',1)
  }else if(intelligenceInfo.memberCategoryId){
    //去升级
    mittBus.emit('showMember',2)
  }
}

</script>

<style lang="scss" scoped>

.member {
  height: 53px;
  box-sizing: border-box;
  padding: 8px 12px 8px 16px;
  background: #F8EED5;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-image: linear-gradient(-29deg, #FEE8C1 0%, #FAE4BB 68%);
  font-family: PingFangSC-Medium;
  font-size: 14px;
  color: #64360D;
  font-weight: 500;

  .member-left {
    .member-left-small {
      font-size: 12px;

      span {
        color: #ff4000;
      }
    }
  }

  .member-btn {
    width: 58px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #64360D;
    border-radius: 12px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #FEE8BC;
    font-weight: 500;
    cursor: pointer;
  }
}
.free-noleft{
  position: relative;
  left: -5px;
  cursor: pointer;
}

.pi{
  width: 228px;
  height: 42px;
  box-sizing: border-box;
  padding: 8px 16px;
  background: #F8EED5;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: PingFangSC-Medium;
  font-size: 14px;
  color: #64360D;
  font-weight: 500;
  .pi-left{
    padding: 5px 0;
    .pil-small{
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #64360D;
      font-weight: 400;
      span{
        color: #FF4000;
      }
    }
  }
  .pi-btn{
    width: 58px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #64360D;
    border-radius: 12px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #FEE8BC;
    font-weight: 500;
    cursor: pointer;
  }
}

.menu {
  padding: 24px 16px;
  background: #FFFFFF;
  height: 100%;
  box-sizing: border-box;
  width: 260px;
  position: relative;
  .title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 10px;
    .t_ai {
      width: 48px;
      height: 48px;
      margin-right: 8px;
    }
    .t_img {
      width: 144px;
      height: 29px;
    }
  }
  .box {
    margin-top: 24px;
    overflow: auto;
    height: calc(100% - 137px);
    .row {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 40px;
      margin: 16px 0px;
      cursor: pointer;
      padding-left: 20px;
      span {
        font-size: 16px;
        color: #191D20;
        letter-spacing: 0;
        font-weight: 400;
      }
      img {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
    }
    .select {
      background: rgba(54,145,252,0.08);
      border-radius: 8px;
      span {
        color: #3691FC;
      }
    }
    .row:hover {
      background: rgba(54,145,252,0.08);
      border-radius: 8px;
      span {
        color: #3691FC;
      }
    }
  }
  .box1 {
    display: flex;
    justify-content: space-around;
    .row {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 40px;
      cursor: pointer;
      span {
        font-size: 14px;
        color: #7E9CB3;
        letter-spacing: 0;
        font-weight: 400;
      }
      img {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
    }
    .row:hover {
      opacity: 0.8;
    }
  }
  .bottom {
    position: absolute;
    bottom: 0px;
    left: 0px;
    cursor: pointer;
    .bot_text {
      position: absolute;
      left: 45px;
      top:30px;
      p:nth-child(1) {
        font-size: 16px;
        color: #3691FC;
        letter-spacing: 0;
        font-weight: 600;
      }
      p:nth-child(2) {
        font-size: 12px;
        color: #374047;
        letter-spacing: 0;
        text-align: center;
        font-weight: 400;
      }
    }
  }
}
.dialog{
  ::v-deep .el-dialog{
    border-radius: 24px;
    padding: 32px 50px;
  }
  .switchTabs{
    font-family: PingFangSC-Regular;
    font-size: 22px;
    color: #6E7881;
    letter-spacing: 0;
    font-weight: 400;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    
    .ft600{
      font-family: PingFangSC-Semibold;
      color: #191D20;
      font-weight: 600;
    }
    .line{
      margin: 0 auto;
      margin-top: 8px;
      background-image: linear-gradient(90deg, #3BE1F9 0%, #3363FF 44%, #9377FF 100%);
      border-radius: 3px;
      width: 48px;
      height: 6px;
    }
    .whiteLine{
      margin: 0 auto;
      margin-top: 8px;
      background:#fff;
      border-radius: 3px;
      width: 48px;
      height: 6px;
    }
  }
  .dialog-title{
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #191D20;
    letter-spacing: 0;
    font-weight: 400;
    margin-bottom: 14px;
    display: flex;
    align-items: center;
    img{
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
  }
  ::v-deep .el-textarea__inner{
    background: #F4F8FD;
    border-radius: 16px;
    padding: 12px 16px;
    font-size: 16px;
  }
  .count{
    margin-top: 7px;
    margin-right: 16px;
    text-align: right;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #A6B6C8;
    letter-spacing: 0;
    font-weight: 400;
  }
  ::v-deep .el-dialog__body{
    padding-bottom: 0;
  }
  .dialog-footer{
    display: flex ;
    align-items: center;
    justify-content: center;
  }
  .confirm{
    background-image: linear-gradient(90deg, #3BE1F9 0%, #3363FF 44%, #9377FF 100%);
    border-radius: 8px;
    width: 136px;
    height: 40px;
    box-sizing: border-box;
    // padding: 10px 45px;
    font-family: PingFangSC-Semibold;
    font-size: 20px;
    color: #FFFFFF;
    letter-spacing: 0;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
